import { render } from "./index.vue?vue&type=template&id=8bc07524&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=8bc07524&lang=less"
import "./index.vue?vue&type=style&index=1&id=8bc07524&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bc07524"]])

export default __exports__